import MenuIcon from "@mui/icons-material/Menu";
import { Button, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Drawer from '@mui/material/Drawer';
import IconButton from "@mui/material/IconButton";
import Link from '@mui/material/Link';
import Toolbar from "@mui/material/Toolbar";
import { makeStyles } from "@mui/styles";
import React from "react";
import MenuDrawer from "./Drawer";
const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDrawer-paper' : {
      backgroundColor: "#18042e !important",
    },
    '& .MuiPaper-root MuiPaper-elevation MuiPaper-elevation16 MuiDrawer-paper': {
      backgroundColor: '#18042e !important'
    }
  },
  appBar: {
    backgroundColor: "#18042e !important",
  },
  menuBtn: {
    my: 2,
    color: "#fff !important",
    display: "block",
  },
  logoBtn: {
    clipPath: 'polygon(0% 0%, 100% 1%, 100% 78%, 52% 100%, 0 78%)',
    backgroundColor: '#f70743',
    color: '#ffff',
    padding: '5px 10px'
  },
  MuiDrawerPaper: {
    background: '#18042e !important',
    '& .MuiDrawer-paper' : {
      backgroundColor: "#18042e !important",
      color: '#fff !important'
    },
    '& .MuiPaper-root MuiPaper-elevation MuiPaper-elevation16 MuiDrawer-paper': {
      backgroundColor: '#18042e !important',
      color: '#fff !important'
    }
  },
  linkBtn: {
    textDecoration: 'none !important',
    '&:hover' : {
      textDecoration: 'none !important'
    }
  }

}));
const pages = ["ABOUT", "SKILL", "PORTFOLIO", "BLOG", "CONTACT"];
export default function Appbar() {
  const classes = useStyles();
  const anchor = 'left';
  // const theme = useTheme();
  // const [anchorElNav, setAnchorElNav] = React.useState(null);

  // const handleOpenNavMenu = (event) => {
  //   setAnchorElNav(event.currentTarget);
  //   setState(true)
  //   console.log(event);
  // };
  const handleToggleMenu = (open) => {
    setState(open)
  }
  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };
  const [state, setState] = React.useState(false);
  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <IconButton
              sx={{ p: 0, mr: 2, display: { xs: "none", md: "flex" } }}
            >
              <div className={classes.logoBtn}>
                <Typography variant="h5">Z</Typography>
              </div>
            </IconButton>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => handleToggleMenu(true)}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor={anchor}
                open={state}
                className={classes.MuiDrawerPaper}
                onClose={() => handleToggleMenu(false)}
              >
                <MenuDrawer anchor={anchor} state={state} classes={classes} handleToggle={handleToggleMenu} />
              </Drawer>
            </Box>
            <IconButton
              sx={{ p: 0, flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              <div className={classes.logoBtn}>
                <Typography variant="h5">Z</Typography>
              </div>
            </IconButton>
            <Box
              sx={{
                flexGrow: 2,
                justifyContent: "flex-end",
                display: { xs: "none", md: "flex" },
              }}
            >
              {pages.map((page) => (
                // <Button
                //   key={page}
                //   // onClick={handleCloseNavMenu}
                //   className={classes.menuBtn}
                //   id={page}
                // >
                //   {page}
                // </Button>
                <Link key={page}  href={`#${page}`} className={classes.linkBtn}>
                  <Button className={classes.menuBtn}>
                    {page}
                  </Button>
                </Link>
              ))}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}
